import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import EuroCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/EuroCircleOutlined";
import AntdIcon from "../components/AntdIcon";
var EuroCircleOutlined = function EuroCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: EuroCircleOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  EuroCircleOutlined.displayName = 'EuroCircleOutlined';
}
export default /*#__PURE__*/React.forwardRef(EuroCircleOutlined);